export type AppSurface = "chat" | "research" | "workspace" | "settings";

interface ScrollTarget {
  scrollTo(options: ScrollToOptions): void;
}

interface InitialSurfaceInput {
  search: string;
  activeAccountId: string | null;
  primaryAccountId: string | null;
}

/**
 * Restore a coherent first screen after authentication rehydrates the persisted
 * active account. A non-primary account is a collaborative workspace, so showing
 * the personal conversation history for it would produce a misleading empty list.
 */
export function resolveInitialSurface({
  search,
  activeAccountId,
  primaryAccountId
}: InitialSurfaceInput): AppSurface {
  if (new URLSearchParams(search).has("invite")) return "workspace";
  if (activeAccountId && primaryAccountId && activeAccountId !== primaryAccountId) return "workspace";
  return "chat";
}

/** Reset mobile-only shared frame offsets before the next surface is painted. */
export function resetMobileSurfaceScroll(
  isMobile: boolean,
  frame: ScrollTarget | null,
  viewport: ScrollTarget
): void {
  if (!isMobile) return;
  const origin: ScrollToOptions = { left: 0, top: 0, behavior: "auto" };
  frame?.scrollTo(origin);
  viewport.scrollTo(origin);
}
